import '../../core/styles/focusRingStatic.css';
import './GroupedChip.css';
export var first = '_4mpedx2-3-15-1';
export var grouped = '_4mpedx1-3-15-1';
export var hidden = '_4mpedx0-3-15-1';
export var pendingFocusRing = {neutral:'_4mpedx3-3-15-1',primary:'_4mpedx4-3-15-1',success:'_4mpedx5-3-15-1',warning:'_4mpedx6-3-15-1',critical:'_4mpedx7-3-15-1'};